var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"previous-step__container"},[(!_vm.tchekImages.completed)?_c('a',{staticClass:"previous-step__link",on:{"click":function($event){$event.preventDefault();return _vm.previousStep(_vm.step)}}},[_vm._v(_vm._s(_vm.linkText))]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fcf9e9e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/valuation-tool/components/Sections/StepLink.vue
// module id = ZW01
// module chunks = 1 2 4 5 15 17 18 19